import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from '../ModuleBlock';
import ModuleService from '../../../../../services/module';

class RoadBookModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
    };

    render() {
        return (
            <ModuleBlock
                app={this.props.app}
                module={ModuleService.getModule(ModuleService.ROAD_BOOK)}
            />
        );
    }
}

export default RoadBookModuleBlock;



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/RoadBookModuleBlock/RoadBookModuleBlock.js